<template>
    <div class="ma-2">
        <!-- add -->
        <v-btn
            @click="dialog = true"
        	small
        	class="text-none my-2"
        	color="addRow white--text"
        >
            <v-icon>
                $add
            </v-icon>
            {{ $t('Holiday.add-holiday') }}
        </v-btn>
        <!-- dialog -->
        <v-dialog v-model="dialog" width="450">
            <v-card>
                <v-card-title primary-title>
                    {{ $t('Holiday.add-holiday') }}
				    <v-spacer></v-spacer>
                    <v-btn
                        @click="dialog = false"
                        icon>
                        <v-icon color="alert-color">mdi-close</v-icon>
                    </v-btn>
			    </v-card-title>
                <v-form ref="form" @submit.prevent="create">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" class="mb-2">
                                <bee-date-picker
                                    v-model="dataDialog.date"
                                    :input-label="$T('inputs.date')"
                                    :input-props="{ 
                                        outlined: true, 
                                        dense: true, 
                                        prependInnerIcon: '$calendar', 
                                        disabled: submitLoading 
                                    }"
                                    :months-over-max="100"
                                    menu-picker
                                    calendar
                                    no-title
                                    hide-details
                                ></bee-date-picker>
                            </v-col>
                            <v-col cols="6" class="mb-2">
                                <bee-date-picker
                                    v-model="dataDialog.startDate"
                                    :input-label="$T('inputs.start-date')"
                                    :input-props="{ 
                                        outlined: true, 
                                        dense: true, 
                                        prependInnerIcon: '$calendar', 
                                        disabled: submitLoading 
                                    }"
                                    :months-over-max="100"
                                    menu-picker
                                    calendar
                                    no-title
                                    hide-details
                                ></bee-date-picker>
                            </v-col>
                            <v-col cols="6" class="mb-2">
                                <v-text-field 
                                    v-model="dataDialog.durationInDay"
                                    type="number"
                                    :label="$t('Holiday.inputs.duration-in-days')"
                                    outlined
                                    dense
                                    hide-details
                                    :disabled="submitLoading"
                                />
                            </v-col>

                            <v-col cols="6" class="mb-2">
                                <v-autocomplete 
                                    v-model="dataDialog.jobDescriptionIds"
                                    :items="jobDescriptions"
                                    item-text="name"
                                    item-value="id"
                                    outlined
                                    dense
                                    hide-details
                                    :disabled="submitLoading || dataDialog.forAllEmployee"
                                    :label="$t('Holiday.inputs.job-descriptions')"
                                    multiple
                                    :rules="(dataDialog.employeeIds.length !== 0 && dataDialog.forAllEmployee === false) ? [val => val.length !== 0 || 'required'] : []"
                                />
                            </v-col>

                            <v-col cols="6" class="mb-2">
                                <v-checkbox 
                                    v-model="dataDialog.forAllEmployee"
                                    class="my-0 py-0"
                                    :label="$t('Holiday.inputs.all-employees')"
                                    dense
                                    hide-details
                                    :disabled="submitLoading"
                                />
                            </v-col>

                            <v-col cols="6" class="mb-2">
                                <v-autocomplete
                                    v-model="dataDialog.employeeIds"
                                    :items="employees"
                                    item-text="arabicFullName"
                                    item-value="employeeId"
                                    hide-details
                                    outlined
                                    dense
                                    :disabled="submitLoading || dataDialog.forAllEmployee"
                                    :label="$t('inputs.employees')"
                                    multiple
                                    :rules="(dataDialog.jobDescriptionIds.length !== 0 && dataDialog.forAllEmployee === false) ? [val => val.length !== 0 || 'required'] : []"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    v-model="dataDialog.reason"
                                    :label="$t('Holiday.inputs.reason')"
                                    outlined
                                    dense
                                    hide-details
                                    :disabled="submitLoading"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="align-center">
                        <v-spacer></v-spacer>
                        <v-btn type="submit"  color="secondary">
                            {{ $t('default-buttons.save') }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'holiday/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="getAll(); itemId = null">
			{{ $T('Holiday.delete-message-holiday') }}
		</v-delete-dialog>

        <bee-handy-smart-table
            :items="holidays"
            :headers="headers"
            :items-per-page="-1"
            hide-default-footer
            zebra
            dense
        >

            <!-- all employee -->
            <template v-slot:item.forAllEmployee="{ item }">
                <v-icon v-if="item.forAllEmployee" color="success"> mdi-check-circle </v-icon>
                <v-icon v-else color="alert-color"> mdi-close-circle </v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn 
                    @click="itemId = item.id; dialog = true"
                    icon 
                    color="edit-color"
                >
                    <v-icon>
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-btn 
                    @click="itemId = item.id; deleteDialog = true"
                    icon 
                    color="alert-color"
                >
                    <v-icon>
                        mdi-delete
                    </v-icon>
                </v-btn>
            </template>
        </bee-handy-smart-table>
  
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import rules from '@/utils/validation rules';
export default {
    watch: {
        dialog(val) {
            if(this.itemId) {
                // const item = this.getHolidayById(this.itemId)
                this.dataDialog.date = moment(this.getHolidayById(this.itemId)?.date).format('YYYY-MM-DD')
                this.dataDialog.startDate = moment(this.getHolidayById(this.itemId)?.startDate).format('YYYY-MM-DD')
                this.dataDialog.durationInDay = this.getHolidayById(this.itemId)?.durationInDays
                this.dataDialog.jobDescriptionIds = this.getHolidayById(this.itemId)?.jobDescriptionIds
                this.dataDialog.employeeIds = this.getHolidayById(this.itemId)?.employeeIds
                this.dataDialog.forAllEmployee = this.getHolidayById(this.itemId)?.forAllEmployee
                this.dataDialog.reason = this.getHolidayById(this.itemId)?.reason
            } 
            if (!val) {
                this.dataDialog.date = null
                this.dataDialog.startDate = null
                this.dataDialog.durationInDay = null
                this.dataDialog.jobDescriptionIds = []
                this.dataDialog.employeeIds = []
                this.dataDialog.forAllEmployee = null
                this.dataDialog.reason = null
                this.itemId = null
                this.$refs.form.reset()
            }
        },

        'dataDialog.forAllEmployee'(val) {
            if(val === true) {
                this.dataDialog.employeeIds = []
                this.dataDialog.jobDescriptionIds = []
            }
        }
    },
    data() {
        return {
            dialog: false,
            submitLoading: false,
            jobDescriptions: [],
            dataDialog: {
                durationInDay: 0,
                date: moment().format('YYYY-MM-DD'),
                startDate: null,
                reason: null,
                forAllEmployee: false,
                jobDescriptionIds: [],
                employeeIds: []
            },
            itemId: null,
            deleteDialog: false,
            rules
  
        }
    },

    computed: {
        ...mapState({
            positions: state => state.positions.positions,
            employees: state => state.employee.employees,
            holidays: state => state.holiday.holidays
        }),
        ...mapGetters({
            getHolidayById: 'holiday/getHolidayById'
        }),
        headers () {
            return [
                {
                    text: this.$T('headers.date'),
                    name: 'date',
                    value: 'date',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                },
                {
                    text: this.$t('Holiday.headers.duration-in-days'),
                    name: 'durationInDays',
                    value: 'durationInDays'
                },
                {
                    text: this.$t('Holiday.headers.start-date'),
                    name: 'startDate',
                    value: 'startDate',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                },
                {
                    text: this.$t('Holiday.headers.reason'),
                    name: 'reason',
                    value: 'reason'
                },
                {
                    text: this.$t('Holiday.headers.for-all-employee'),
                    name: 'forAllEmployee',
                    value: 'forAllEmployee'
                }, 
                {
                    text: this.$t('Holiday.headers.job-description'),
                    name: 'jobDescriptionIds',
                    value: 'jobDescriptionIds',
                    setValueExpr: val => val.length ? val.map(c => this.positions.find(i => i.id === c)?.name)?.join(',') : '-'
                },
                {
                    text: this.$t('Holiday.headers.employees'),
                    name: 'employeeIds',
                    value: 'employeeIds',
                    setValueExpr: val => val.length ? val.map(c => this.employees.find(i => i.employeeId === c)?.arabicFullName)?.join(',') : '-'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        }
    },
    
    methods: {
        moment,
        getAll() {
            return this.$store.dispatch('holiday/fetch')
        },
        create() {
            // if(this.dataDialog.forAllEmployee && this.$refs.form.validate()){
            this.submitLoading = true
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`holiday/${actionName}`, { 
                durationInDays: this.dataDialog.durationInDay, 
                date: this.dataDialog.date, 
                startDate: this.dataDialog.startDate, 
                reason: this.dataDialog.reason, 
                forAllEmployee: this.dataDialog.forAllEmployee, 
                jobDescriptionIds: this.dataDialog.jobDescriptionIds, 
                employeeIds: this.dataDialog.employeeIds,
                id: this.itemId ? this.itemId : null
            }).then(() => {
                this.getAll()
            }).finally(() => {
                this.submitLoading = false
                this.dialog = false
            })
            // }
        }
    },

    created () {
        this.getAll()
        this.$store.dispatch('filters/fetchJobDescriptions').then((data) => {
            this.jobDescriptions = data
        })
    }
}
</script>
